import * as React from 'react';
import { Info, CaptionTypography, Conflict } from '@components/atoms';
import { CheckIcon } from '@components/atoms/icons/check-icon';
import OverlineTypography from '@components/atoms/typography/Overline/Overline';
import { InformationLineVariant } from '@components/molecules';
import { cn } from '@utils';

interface Props {
	children: React.ReactNode;
	variant?: InformationLineVariant;
	className?: string;
	iconClassName?: string;
	truncate?: boolean;
}

const variantColors: Record<string, string> = {
	error: 'text-error',
	info: 'text-tertiary',
	helper: 'text-secondary',
	success: 'text-success',
};

const iconComponentMapper = {
	error: Conflict,
	info: Info,
	success: CheckIcon,
	helper: Info,
};

const iconSizeMapper = {
	info: 'h-2 w-2',
	error: 'h-3 w-3',
	helper: 'h-3 w-3',
	success: 'h-3 w-3',
};

const typographyMapper = {
	error: CaptionTypography,
	info: OverlineTypography,
	helper: CaptionTypography,
	success: CaptionTypography,
};

export const InfoLine: React.FC<Props> = ({
	children,
	variant = InformationLineVariant.HELPER,
	className,
	iconClassName,
	truncate = true,
}) => {
	const textColor = variantColors[variant];
	const IconComponent = iconComponentMapper[variant];
	const iconSize = iconSizeMapper[variant];
	const TypographyComponent = typographyMapper[variant];
	return (
		<div className={cn(`flex items-center gap-1`, className)}>
			<IconComponent className={cn(`${iconSize} ${textColor} self-start shrink-0`, iconClassName)} />
			<TypographyComponent className={textColor} truncate={truncate}>
				{children}
			</TypographyComponent>
		</div>
	);
};
